import dayjs from 'dayjs';
var appVersionNumber = process.env.REACT_APP_VERSION;
var AnalyticsEvent = /** @class */ (function () {
    function AnalyticsEvent(sessionId, eventName, pathName, extraData, userProxy) {
        this.versionNumber = appVersionNumber;
        this.sessionId = sessionId.toString();
        this.timeStamp = dayjs().toDate();
        this.eventName = eventName;
        this.extraData = extraData;
        this.pathName = pathName;
        this.userProxy = userProxy;
    }
    return AnalyticsEvent;
}());
export default AnalyticsEvent;
